import React from 'react';
import Modal from '../shared/Modal';
import Formsy from 'formsy-react';
import FormsySimpleInput from '../form/FormsySimpleInput';
import MoneyInput from '../form/MoneyInput';
import FormsySimpleTextArea from '../form/FormsySimpleTextArea';
import FormRadio from '../form/Radio';
import Checkbox from '../form/Checkbox';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import { dollarsToCents } from '../../helpers/util';
import { mailToQ } from '../../const';

class ClientEditDetailsModal extends React.Component {
  state = {
    client: {
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      base_fee_cents: '',
      portion_size: '',
      status: '',
      other_allergens: '',
      dietary_preference_tags: [],
      allergen_tags: [],
      special_instructions: []
    },
    availableDiets: [],
    availableAllergens: []
  };

  portionOptions = [
    { value: 'small', label: 'Small (1-2 mouths)' },
    { value: 'medium', label: 'Medium (3-4 mouths)' },
    { value: 'large', label: 'Large (5-6 mouths)' }
  ];

  statusOptions = [
    { value: 'standard', label: 'Standard' },
    { value: 'vip', label: 'VIP' },
    { value: 'high_alert', label: 'High Alert' },
    { value: 'probation', label: 'Probation' },
  ];

  render() {
    const { handleChange, handleSubmit } = this;
    const {
      isOpen,
      closeModal,
      allowEditEmail = false,
      showBaseRate = false
    } = this.props;
    const { availableDiets, availableAllergens } = this.state;
    const {
      first_name,
      last_name,
      email,
      phone_number,
      portion_size,
      other_allergens,
      dietary_preference_tags,
      allergen_tags,
      base_fee_cents,
      special_instructions,
      status
    } = this.state.client;

    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <div className='admin-wrapper'>
          <h2 className="h2 modal__heading">Edit Details</h2>
          <Formsy className="form" onValidSubmit={handleSubmit}>
            <div className="form__row">
              <div className="form__row-item form__row-item--half">
                <p className="simple-input__label">First Name</p>
                <FormsySimpleInput
                  type="text"
                  name="first_name"
                  placeholder=""
                  value={first_name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form__row-item form__row-item--half">
                <p className="simple-input__label">Last Name</p>
                <FormsySimpleInput
                  type="text"
                  name="last_name"
                  placeholder=""
                  value={last_name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form__row form__row--align-top">
              <div className="form__row-item form__row-item--half">
                <p className="simple-input__label">Email</p>

                {allowEditEmail ? (
                  <FormsySimpleInput
                    type="text"
                    name="email"
                    placeholder=""
                    value={email}
                    onChange={handleChange}
                    required
                  />
                ) : (
                  <div className="simple-input__locked">
                    <p className="p">{email}</p>
                    <a className="a--blue" href={mailToQ}>
                      To edit your email, please contact us.
                    </a>
                  </div>
                )}
              </div>
              <div className="form__row-item form__row-item--half">
                <p className="simple-input__label">Phone</p>
                <FormsySimpleInput
                  type="text"
                  name="phone_number"
                  placeholder=""
                  value={phone_number}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form__row">
              <div className="form__row-item form__row-item--full">
                <p className="simple-input__label">Client Status</p>
                <FormRadio
                  className="radio--blue radio--large radio--full-width"
                  name="status"
                  placeholder=""
                  options={this.statusOptions}
                  value={status}
                  onChange={this.handleChange}
                />
              </div>
            </div>

            <div className="form__row">
              <div className="form__row-item form__row-item--full">
                <p className="simple-input__label">Portion Size</p>
                <FormRadio
                  className="radio--blue radio--large radio--full-width"
                  name="portion_size"
                  placeholder=""
                  options={this.portionOptions}
                  value={portion_size || ''}
                  onChange={this.handleChange}
                />
              </div>
            </div>

            <div className="form__row">
              <h2 className="dish-edit__label">Diet</h2>
              <div className="checkbox-row">
                {this.renderCheckboxes(
                  availableDiets,
                  dietary_preference_tags,
                  'dietary_preference_tags'
                )}
              </div>
            </div>

            <div className="form__row">
              <h2 className="dish-edit__label">Allergens</h2>
              <div className="checkbox-row">
                {this.renderCheckboxes(
                  availableAllergens,
                  allergen_tags,
                  'allergen_tags'
                )}
              </div>
            </div>

            <div className="form__row">
              <div className="form__row-item form__row-item--full">
                <p className="simple-input__label">Other Food Allergens</p>
                <FormsySimpleInput
                  type="text"
                  name="other_allergens"
                  placeholder=""
                  value={other_allergens || ''}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form__row">
              <div className="form__row-item form__row-item--full">
                <p className="simple-input__label">Special Instructions</p>
                <FormsySimpleTextArea
                  type="text"
                  name="special_instructions"
                  placeholder=""
                  value={special_instructions || ''}
                  onChange={handleChange}
                />
              </div>
            </div>

            {showBaseRate && (
              <div className="form__row">
                <div className="form__row-item form__row-item--full">
                  <p className="simple-input__label">Base Rate</p>
                  <MoneyInput
                    className="simple-input"
                    type="text"
                    name="base_fee_cents"
                    valueCents={base_fee_cents || 0}
                    onChange={(cents) => this.handleBaseFeeChange(cents)}
                  />
                </div>
              </div>
            )}

            <div className="form__row">
              <div className="form__row-item--half">
                <div
                  className="btn btn--hollow-red-bright btn--full-width"
                  onClick={closeModal}
                >
                  Cancel
                </div>
              </div>
              <div className="form__row-item--half">
                <input
                  type="submit"
                  className="btn btn--solid-blue btn--full-width"
                  value="Save"
                />
              </div>
            </div>
          </Formsy>
        </div>
      </Modal>
    );
  }

  renderCheckboxes(items, selectedItems, key) {
    const { isChecked, toggleChecked } = this;
    if (!items || items.length < 1) return;
    return items.map(item => (
      <div
        key={item.id}
        className="checkbox-row__item checkbox-row__item--third"
      >
        <Checkbox
          name={item.tag}
          className="checkbox--large checkbox--large-blue checkbox--flex form__row-item--third"
          placeholder={item.tag}
          checked={isChecked(item, selectedItems)}
          onChange={e => toggleChecked(item, selectedItems, key)}
        />
      </div>
    ));
  }

  isChecked = (value, selectedItems = []) => {
    return selectedItems.findIndex(val => val.id === value.id) >= 0;
  };

  toggleChecked = (value, selectedItems = [], key) => {
    if (this.isChecked(value, selectedItems)) {
      // delete
      const index = selectedItems.findIndex(val => val.id === value.id);
      selectedItems = [
        ...selectedItems.slice(0, index),
        ...selectedItems.slice(index + 1, selectedItems.length)
      ];
    } else selectedItems = [...selectedItems, value];

    const client = {
      ...this.state.client,
      [key]: selectedItems
    };
    this.setState({ client });
  };

  handleSubmit = () => {
    const client = { ...this.state.client };
    if (client.email !== this.props.client.email) {
      client.unconfirmed_email = client.email;
      client.email = this.props.client.email;
    }
    this.props.updateClient(client);
  };

  handleBaseFeeChange = cents => {
    const client = {
      ...this.state.client,
      'base_fee_cents': cents
    };
    this.setState({ client });
  }

  handleChange = e => {
    const { target } = e;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if (value.charAt(0) === '$') value = dollarsToCents(value);

    const client = {
      ...this.state.client,
      [name]: value
    };

    this.setState({ client });
  };

  componentDidMount() {
    // initialize state from props
    this.setState({ client: this.props.client });

    menuAPI
      .getDiets()
      .then(({ dietary_preference_tags: availableDiets }) =>
        this.setState({ availableDiets })
      )
      .catch(error => console.log(error));

    menuAPI
      .getAllergens()
      .then(({ allergen_tags: availableAllergens }) =>
        this.setState({ availableAllergens })
      )
      .catch(error => console.log(error));
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (this.props.client !== prevProps.client)
      this.setState({ client: this.props.client });
  }
}

export default ClientEditDetailsModal;



// WEBPACK FOOTER //
// ./src/components/client/ClientEditDetailsModal.js